@if (isLoading) {
  <div class="loader-overlay" role="status" aria-live="polite">
    <div class="heart-wrapper" aria-hidden="true">
      <svg class="heart-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          class="heart-shape"
          d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 6 4 4 6.5 4 
               8.24 4 9.91 5 10.54 6.36 11.17 5 12.76 4 14.5 4 
               17 4 19 6 19 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
        />
        <polyline class="ekg" points="3 12 7 12 9 8 11 15 13 6 15 12 21 12" fill="none" />
      </svg>
    </div>

    <p class="loader-text mt-3 fw-semibold text-dark">Loading...</p>
  </div>
}

@if (!isLoading) {
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-4">
        <h3 class="mb-4 text-center">OTP Verification</h3>

        <form [formGroup]="form" (ngSubmit)="submitOtp()">
          <div class="mb-3">
            <label for="otp" class="form-label">Enter OTP</label>
            <input
              id="otp"
              type="text"
              class="form-control text-center"
              maxlength="5"
              formControlName="otp"
              placeholder="Enter 5-digit code"
            />
            <div
              class="text-danger small mt-1"
              *ngIf="form.get('otp')?.touched && form.get('otp')?.invalid"
            >
              OTP must be 5 digits.
            </div>
          </div>

          <div class="d-grid gap-2 mt-4">
            <button class="btn btn-primary" type="submit" [disabled]="isLoading || form.invalid">
              Verify OTP
            </button>

            <button
              class="btn btn-link text-primary"
              type="button"
              (click)="resendOtp()"
              [disabled]="isLoading"
            >
              Resend OTP
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
}
